import { FC, useState, useMemo } from 'react';
import { Typography } from '@kizen/kds/Typography';
import { Button } from '@kizen/kds/Button';
import { TypingIndicator } from './TypingIndicator';
import { MarkdownContainer } from './styles';
import { markdownToHtmlSync } from '@kizen/parse-md';

interface StatusDetailsDropdownProps {
  content: string;
  isStreaming: boolean;
  summaryContent: string;
}

export const StatusDetailsDropdown: FC<StatusDetailsDropdownProps> = ({
  content,
  isStreaming,
  summaryContent,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const parsedContent = useMemo(
    () => markdownToHtmlSync(content, { forceExternalLinks: true }),
    [content]
  );

  if (!content) return null;

  return (
    <div className="mt-[10px] mb-[2px]">
      <div className="relative h-[32px] flex-shrink-0">
        <div className="absolute left-[-15px] top-[2px] bottom-0 flex items-center">
          <Button
            variant="text"
            color="inherit"
            size="small"
            rightIcon={
              isExpanded ? 'action-collapse-frame' : 'action-expand-frame'
            }
            onClick={() => setIsExpanded((prev) => !prev)}
            qa={{
              action: 'toggle-status-details',
              type: 'button',
            }}
          />
        </div>
        <div className="absolute left-0 top-0 bottom-0 flex items-center whitespace-nowrap">
          {isStreaming ? (
            <TypingIndicator
              label={summaryContent}
              color={isExpanded ? 'font-secondary' : 'font-placeholder'}
              size="md"
              inline
            />
          ) : (
            <Typography
              size="md"
              color={isExpanded ? 'font-secondary' : 'font-placeholder'}
            >
              {summaryContent}
            </Typography>
          )}
        </div>
      </div>

      {isExpanded && (
        <div className="pt-[10px] pl-[2px] pb-[2px] animate-fadeDown">
          <MarkdownContainer
            className="kds"
            color="font-placeholder"
            dangerouslySetInnerHTML={{ __html: parsedContent }}
          />
        </div>
      )}
    </div>
  );
};
